































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class NavBar extends Vue {
  @Prop()
  private msg!: string;

  private openBlog() {
      window.open('https://blog.jisotravel.com/', '_blank');
    }
}
